"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _stencilReactDesc = require("@amzn/stencil-react-desc");

var _button = require("../../button");

var _context = require("../../context");

var _form = require("../../form");

var _icons = require("../../icons");

var _layout = require("../../layout");

var _popover = require("../../popover");

var _utils = require("../../utils");

var _helperComponents = require("../helperComponents");

var _ = require(".");

var _constants = require("./constants");

var _propTypes = require("./propTypes");

var _utils2 = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["shouldDisplay24Hours", "onChange", "selectedTime", "labelText", "renderLabel", "clearButtonAltText", "timePickerButtonAltText", "invalidValueErrorText", "inputProps", "popoverProps"],
    _excluded2 = ["position", "offset"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var PopupTimePicker = function PopupTimePicker(_ref) {
  var shouldDisplay24Hours = _ref.shouldDisplay24Hours,
      onChange = _ref.onChange,
      selectedTime = _ref.selectedTime,
      labelText = _ref.labelText,
      _ref$renderLabel = _ref.renderLabel,
      renderLabel = _ref$renderLabel === void 0 ? _constants.popupTimePickerDefaultProps.renderLabel : _ref$renderLabel,
      _ref$clearButtonAltTe = _ref.clearButtonAltText,
      clearButtonAltText = _ref$clearButtonAltTe === void 0 ? _constants.popupTimePickerDefaultProps.clearButtonAltText : _ref$clearButtonAltTe,
      _ref$timePickerButton = _ref.timePickerButtonAltText,
      timePickerButtonAltText = _ref$timePickerButton === void 0 ? _constants.popupTimePickerDefaultProps.timePickerButtonAltText : _ref$timePickerButton,
      invalidValueErrorText = _ref.invalidValueErrorText,
      inputProps = _ref.inputProps,
      popoverProps = _ref.popoverProps,
      timePickerProps = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var is24Hours = !!shouldDisplay24Hours;

  var _useState = (0, _react.useState)(selectedTime ? (0, _utils2.segmentValuesToTimeString)(selectedTime, is24Hours) : ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var initialValue = selectedTime ? (0, _utils2.partialTimeStringToSegmentValuesWithPeriod)((0, _utils2.segmentValuesToTimeString)(selectedTime, is24Hours), is24Hours) : {};

  var _useState3 = (0, _react.useState)(initialValue),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      internalSegmentValue = _useState4[0],
      setInternalSegmentValue = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      isOpen = _useState6[0],
      setIsOpen = _useState6[1];

  var _useState7 = (0, _react.useState)(inputProps && !!inputProps.error || false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      hasError = _useState8[0],
      setHasError = _useState8[1];

  var _useState9 = (0, _react.useState)(false),
      _useState10 = (0, _slicedToArray2.default)(_useState9, 2),
      shouldFocusAfterClear = _useState10[0],
      setShouldFocusAfterClear = _useState10[1];

  var _useContext = (0, _react.useContext)(_context.StencilPopoverContext),
      setHasOpenedPopover = _useContext.setHasOpenedPopover;

  var previousSelectedTime = (0, _react.useRef)(selectedTime);
  var inputId = inputProps && inputProps.id ? inputProps.id : (0, _utils.getUniqueId)('TimePickerInput');
  var errorFooterId = (0, _utils.getUniqueId)('TimePickerErrorFooter');
  var inputWidth = inputProps && inputProps.width ? inputProps.width : _constants.POPUP_TIME_PICKER_DEFAULT_WIDTH;
  var isDisabled = inputProps && inputProps.disabled ? inputProps.disabled : false;
  var inputRef = (0, _react.useRef)(null);
  var timePickerButtonRef = (0, _react.useRef)(null);
  var maskPlaceholder = (0, _utils2.getPopupTimePickerMaskPlaceholder)(is24Hours);
  var isInputEmpty = inputValue === (0, _utils2.getPopupTimePickerMaskPlaceholder)(is24Hours) || inputValue === '';
  var isInputValueInvalid = !(0, _utils2.isValidTimeString)(inputValue, is24Hours) && !isInputEmpty;

  var _popupTimePickerDefau = _objectSpread(_objectSpread({}, _constants.popupTimePickerDefaultProps.popoverProps), popoverProps),
      popoverPosition = _popupTimePickerDefau.position,
      popoverOffset = _popupTimePickerDefau.offset,
      restPopoverProps = (0, _objectWithoutProperties2.default)(_popupTimePickerDefau, _excluded2);

  (0, _react.useEffect)(function () {
    if (!!selectedTime && selectedTime !== previousSelectedTime.current) {
      if (Object.keys(selectedTime).length === 0 && (0, _utils2.isValidTimeString)(inputValue, is24Hours)) {
        setInputValue('');
        setInternalSegmentValue({});
        setHasError(false);
      } else if (Object.keys(selectedTime).length !== 0) {
        var newValue = (0, _utils2.segmentValuesToTimeString)(selectedTime, is24Hours);

        if (newValue !== inputValue) {
          setInputValue(newValue);
          setInternalSegmentValue((0, _utils2.partialTimeStringToSegmentValuesWithPeriod)(newValue, is24Hours));

          if ((0, _utils2.isValidTimeString)(newValue, is24Hours)) {
            setHasError(false);
          }
        }
      }

      previousSelectedTime.current = selectedTime;
    }

    if (shouldFocusAfterClear) {
      inputRef.current && inputRef.current.focus();
      setShouldFocusAfterClear(false);
    }
  }, [selectedTime, is24Hours, inputValue, shouldFocusAfterClear]);

  var togglePopover = function togglePopover(event) {
    event.stopPropagation();
    setIsOpen(function (curr) {
      return !curr;
    });
  };

  var handleChange = function handleChange(value) {
    !!onChange && onChange(value);
  };

  var handleClear = function handleClear() {
    handleChange({});
    setInputValue('');
    setInternalSegmentValue({});
    setHasError(false);
  };

  var handlePopoverClose = function handlePopoverClose() {
    if (isInputValueInvalid) {
      setHasError(true);
    } else {
      setHasError(false);
    }

    setIsOpen(false);
  };

  var handlePopoverOnOpened = function handlePopoverOnOpened() {
    setHasOpenedPopover(true);
  };

  var handlePopoverOnClosed = function handlePopoverOnClosed() {
    setHasOpenedPopover(false);
  };

  var handleClearButtonClick = function handleClearButtonClick() {
    handleClear();
    setShouldFocusAfterClear(true);
  };

  var handlePossibleNewValue = function handlePossibleNewValue(value) {
    setInternalSegmentValue(function (curr) {
      return _objectSpread(_objectSpread({}, curr), (0, _utils2.partialTimeStringToSegmentValuesWithPeriod)(value, is24Hours));
    });

    if ((0, _utils2.isValidTimeString)(value, is24Hours)) {
      handleChange((0, _utils2.fullTimeStringToSegmentValues)(value, is24Hours));
      setHasError(false);
    } else if ((0, _utils2.isValidTimeString)(inputValue, is24Hours)) {
      handleChange({});
    }

    setInputValue(value);
  };

  var handleInputOnChange = function handleInputOnChange(event) {
    if (!event.target.value) return;
    var incomingValue = event.target.value.toUpperCase();
    handlePossibleNewValue(incomingValue);
  };

  var handleBaseTimePickerOnChange = function handleBaseTimePickerOnChange(newValue) {
    var fullNewValue = _objectSpread(_objectSpread({}, internalSegmentValue), newValue);

    var newInputValue = (0, _utils2.partialSegmentValuesWithPeriodToTimeString)(fullNewValue, is24Hours);
    handlePossibleNewValue(newInputValue);
  };

  var handleInputOnBlur = function handleInputOnBlur(event) {
    if (event.relatedTarget !== timePickerButtonRef.current && isInputValueInvalid) {
      setHasError(true);
    }

    if (!!inputProps && !!inputProps.onBlur) {
      inputProps.onBlur(event);
    }
  };

  var handleTimePickerButtonOnBlur = function handleTimePickerButtonOnBlur(event) {
    if (!isOpen && event.relatedTarget !== inputRef.current && isInputValueInvalid) {
      setHasError(true);
    }
  };

  var hasErrorState = inputProps && !!inputProps.error || hasError;
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_layout.Col, {
    gridGap: "S100"
  }, labelText && renderLabel({
    htmlFor: inputId,
    hasError: hasError,
    labelText: labelText
  }), (0, _core.jsx)(_form.MaskedInput, (0, _extends2.default)({}, inputProps, {
    id: inputId,
    ref: inputRef,
    placeholder: (0, _utils2.getPopupTimePickerPlaceholder)(is24Hours),
    maskPlaceholder: maskPlaceholder,
    mask: is24Hours ? _constants.POPUP_TIME_PICKER_MASK_24_HOURS : _constants.POPUP_TIME_PICKER_MASK_12_HOURS,
    onClick: togglePopover,
    value: inputValue,
    onChange: handleInputOnChange,
    onBlur: handleInputOnBlur,
    width: inputWidth,
    "aria-describedby": hasErrorState ? errorFooterId : undefined,
    error: hasErrorState,
    "aria-invalid": hasErrorState,
    insetElementTrailing: {
      element: (0, _core.jsx)(_layout.Row, null, !isDisabled && (0, _core.jsx)(_helperComponents.DatePickerButton, {
        icon: (0, _core.jsx)(_icons.IconClock, {
          title: timePickerButtonAltText
        }),
        size: _button.ButtonSize.Small,
        variant: _button.ButtonVariant.Tertiary,
        onClick: togglePopover,
        "aria-expanded": isOpen,
        ref: timePickerButtonRef,
        onBlur: handleTimePickerButtonOnBlur
      }), !isInputEmpty && !isDisabled && (0, _core.jsx)(_helperComponents.DatePickerButton, {
        icon: (0, _core.jsx)(_icons.IconCross, {
          title: clearButtonAltText
        }),
        size: _button.ButtonSize.Small,
        variant: _button.ButtonVariant.Tertiary,
        onClick: handleClearButtonClick,
        tabIndex: isOpen ? -1 : undefined
      })),
      inset: 6
    }
  })), hasErrorState && (0, _core.jsx)(_form.InputFooter, {
    id: errorFooterId,
    error: true,
    width: inputWidth
  }, invalidValueErrorText || (0, _utils2.getDefaultInvalidValueErrorText)(is24Hours))), (0, _core.jsx)(_popover.PopoverController, (0, _extends2.default)({}, restPopoverProps, {
    close: handlePopoverClose,
    isOpen: isOpen,
    offset: popoverOffset,
    onClosed: handlePopoverOnClosed,
    onOpened: handlePopoverOnOpened,
    position: popoverPosition,
    target: inputRef
  }), (0, _core.jsx)(_layout.View, {
    width: _constants.POPUP_TIME_PICKER_POPOVER_WIDTH,
    padding: {
      top: _constants.POPUP_TIME_PICKER_VERTICAL_PADDING,
      bottom: _constants.POPUP_TIME_PICKER_VERTICAL_PADDING
    }
  }, (0, _core.jsx)(_.TimePicker, (0, _extends2.default)({}, timePickerProps, {
    handleChange: handleBaseTimePickerOnChange,
    selectedTime: internalSegmentValue,
    showPeriod: !is24Hours
  })))));
};

var PopupTimePickerWithDocs = (0, _stencilReactDesc.describe)(PopupTimePicker).description('Interactive input for choosing a time.');
PopupTimePickerWithDocs.propTypes = _propTypes.popupTimePickerPropTypes;
PopupTimePickerWithDocs.displayName = 'PopupTimePicker';
var _default = PopupTimePickerWithDocs;
exports.default = _default;